import { selectPreferitiManifestazione } from 'features/sport/selectors';
import { useTypedSelector } from 'lib/centralStore';

export const useIsManifestazionePreferito = (id: string) => {
  const preferiti = useTypedSelector(selectPreferitiManifestazione);
  return preferiti?.some((preferito) => preferito.id === id);
};
